import { useEffect, useRef } from "react";
import { IoMdCloseCircle } from "react-icons/io";
import { IoCheckmarkCircleSharp } from "react-icons/io5";
import { RiResetLeftLine } from "react-icons/ri";
import { useShallow } from "zustand/react/shallow";
import { useFDAChangeManagementFlow } from "../../../hooks/useFDAChangeManagementFlow";
import { useFDAChangeManagementStore } from "../../../store/useFDAChangeManagementStore";

const DecisionChart = () => {
  const decisionFlow = useFDAChangeManagementStore(
    useShallow((state) => state.decisionFlow),
  );
  const [, , resetFlow] = useFDAChangeManagementFlow();
  const chartEndRef = useRef(null);

  const scrollToBottom = () => {
    chartEndRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "nearest",
    });
  };

  useEffect(() => {
    scrollToBottom();
  }, [decisionFlow]);

  return (
    <div
      style={{ maxHeight: "calc(100vh - 170px)" }}
      className="overflow-y-scroll"
    >
      <button
        className="btn absolute top-0 right-0 z-10 mt-4 mr-4 border-none bg-gray-50 hover:border-none"
        onClick={() => resetFlow()}
      >
        <RiResetLeftLine />
        Reset
      </button>
      <ul ref={chartEndRef} className="timeline timeline-vertical">
        {decisionFlow.map((item, index) => (
          <li key={index}>
            <hr />
            {
              <div
                className={
                  "timeline-middle text-2xl " +
                  (item.answer === "yes" ? "text-success" : "text-red-500")
                }
              >
                {item.answer === "yes" && <IoCheckmarkCircleSharp />}
                {item.answer === "no" && <IoMdCloseCircle />}
              </div>
            }
            <div
              className={
                "timeline-box my-1 " +
                (item.answer === "yes"
                  ? "timeline-start border-success"
                  : "timeline-end border-red-500")
              }
            >
              {item.question.question}
            </div>
            <hr />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DecisionChart;
